/**
 * @generated SignedSource<<891ad20a09372e625fb1471c1a60670a>>
 * @relayHash 9fbbf2e9fb6efe716113fe055191fca5
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9fbbf2e9fb6efe716113fe055191fca5

import { ConcreteRequest } from 'relay-runtime';
export type De_markPatientAsPotentialDuplicateInput = {
  patientId: string;
};
export type deMarkPatientAsPotentialDuplicateMutation$variables = {
  input: De_markPatientAsPotentialDuplicateInput;
};
export type deMarkPatientAsPotentialDuplicateMutation$data = {
  readonly markPatientAsPotentialDuplicate: {
    readonly boolean: boolean | null;
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message?: string;
    }> | null;
  };
};
export type deMarkPatientAsPotentialDuplicateMutation = {
  response: deMarkPatientAsPotentialDuplicateMutation$data;
  variables: deMarkPatientAsPotentialDuplicateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "markPatientAsPotentialDuplicate",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "De_markPatientAsPotentialDuplicatePayload",
    "kind": "LinkedField",
    "name": "de_markPatientAsPotentialDuplicate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "boolean",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "Error",
            "abstractKey": "__isError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deMarkPatientAsPotentialDuplicateMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deMarkPatientAsPotentialDuplicateMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "9fbbf2e9fb6efe716113fe055191fca5",
    "metadata": {},
    "name": "deMarkPatientAsPotentialDuplicateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "5198932a987b45acc295c8ba76cd70bd";

export default node;
